import React, { memo, useCallback, useRef } from "react";
import { Button, Truncate } from "@oxygen/core";
import PropTypes from "prop-types";
import getThemeClasses from "@oxygen/theme";
import styles from "./scss/NewCarsSearchWidget.module.scss";
import { CSSFlex } from "GlobalComponent/CSSCore";
import { Search } from "@oxygen/icons";
import { CustomGlobalSearch } from "SrcPath/GlobalSearch/CustomGlobalSearch";
import { platform as PLATFORM } from "SrcPath/enum/Platform";
import { fireInteractiveTracking } from "GlobalUtils/Analytics";
import { NEW_CARS_ENDPOINT } from "SrcPath/NewCars/constants/Global";

const propTypes = {
  /**This is the callback for global search */
  openGlobalSearch: PropTypes.func.isRequired,
  /**This is the custom placeholder for search text and this is optional */
  newCarPlaceHolder: PropTypes.object,
};

const containerClasses = getThemeClasses(`
  align-items-center;
  pl-4;
  pr-3;
  overflow-hidden;
`);

const searchIconContainerClasses = getThemeClasses(`
  flex-shrink-0;
`);

const searchPlaceholderClasses = getThemeClasses(`
  font-size-8;
  ml-2;
  color-darkGray;
`);

const customSearchContainerClasses = getThemeClasses(`
  width-full;
`);

const searchButtonClasses = getThemeClasses(`
  mr-0.5;
`);

const NewCarsSearchWidget = memo(function NewCarsSearchWidget({
  openGlobalSearch,
  newCarPlaceHolder,
  platform,
}) {
  const isMobile = platform.id === PLATFORM.MOBILE.id;
  const placeHolderText =
    newCarPlaceHolder && newCarPlaceHolder.adHtml
      ? newCarPlaceHolder.adHtml
      : "Type to select car name";
  const inputRef = useRef(null);
  const handleSearchButtonClick = useCallback(() => {
    const searchTerm = inputRef && inputRef.current && inputRef.current.value;
    if (searchTerm) {
      fireInteractiveTracking(
        `FirstPanel-${platform.trackingName}-HP`,
        "NewCars-No-Result-Search-Find-Car",
        searchTerm
      );
    }
    const searchUrl = searchTerm
      ? `/search/results/?cx=002963291331112848676:ccmsgcrw20s&cof=FORID:9&ie=UTF-8&q=${searchTerm}&sa=Search&siteurl=www.carwale.com-F#1200`
      : NEW_CARS_ENDPOINT;
    window.location.href = searchUrl;
  }, [platform]);
  return isMobile ? (
    <CSSFlex onClick={openGlobalSearch} className={containerClasses}>
      <div className={searchIconContainerClasses}>
        <Search lazyLoad={false} />
      </div>
      <Truncate
        className={`${searchPlaceholderClasses} ${styles.searchPlaceholder}`}
        data-testing-id="new-car-search"
      >
        {placeHolderText}
      </Truncate>
    </CSSFlex>
  ) : (
    <>
      <CustomGlobalSearch
        platform={platform}
        placeHolder={placeHolderText}
        size="lg"
        customClasses={`${customSearchContainerClasses} ${styles.globalSearchContainer}`}
        inputRef={inputRef}
      />
      <Button
        size="md"
        className={searchButtonClasses}
        paddingXClassName={styles.searchButtonPadding}
        onClick={handleSearchButtonClick}
      >
        {"Search"}
      </Button>
    </>
  );
});

NewCarsSearchWidget.propTypes = propTypes;
NewCarsSearchWidget.displayName = "NewCarsSearchWidget";
export default NewCarsSearchWidget;
